const InteractiveMap = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const tagsContainer = document.querySelector('.interactive-map__tags');
        if (!tagsContainer) return;

        const tags = document.querySelectorAll('.interactive-map__tag');
        const locations = document.querySelectorAll('.interactive-map__location');

        const setActive = (id) => {
            tags.forEach(t => t.classList.remove('is-active'));
            locations.forEach(l => l.classList.remove('is-active'));

            const activeTag = document.querySelector(`.interactive-map__tag[data-location="${id}"]`);
            const activeDot = document.querySelector(`.interactive-map__location[data-location="${id}"]`);

            if (activeTag) activeTag.classList.add('is-active');
            if (activeDot) activeDot.classList.add('is-active');
        };

        // Detect the centered tag on scroll
        let isScrolling;
        tagsContainer.addEventListener('scroll', () => {
            clearTimeout(isScrolling);

            isScrolling = setTimeout(() => {
                const containerCenter = tagsContainer.scrollLeft + tagsContainer.offsetWidth / 2;

                let closestTag = null;
                let closestDistance = Infinity;

                tags.forEach(tag => {
                    const tagCenter = tag.offsetLeft + tag.offsetWidth / 2;
                    const distance = Math.abs(containerCenter - tagCenter);

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestTag = tag;
                    }
                });

                if (closestTag) {
                    const id = closestTag.dataset.location;
                    setActive(id);
                }
            }, 25); // debounce to avoid firing too often
        });
        

        // mobile click functionality
        if (window.innerWidth < 769) {
            
            tags.forEach(tag => {
                tag.addEventListener('click', (e) => {
                    // stop browser auto-scrolling
                    e.preventDefault();
                    e.stopPropagation();
                    tag.blur();
    
                    const preserveScroll = () =>
                        window.scrollTo({ top: window.scrollY, left: window.scrollX, behavior: "instant" });
    
                    preserveScroll();
    
                    const id = tag.dataset.location;
                    setActive(id);
    
                    // Optionally scroll to that tag smoothly
                    tag.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    
                    preserveScroll();
                });
            });
    
    
            locations.forEach(location => {
                location.addEventListener('click', (e) => {
                    // stop browser auto-scrolling
                    e.preventDefault();
                    e.stopPropagation();
                    location.blur();
    
                    const preserveScroll = () =>
                        window.scrollTo({ top: window.scrollY, left: window.scrollX, behavior: "instant" });
    
                    preserveScroll();
    
                    const id = location.dataset.location;
                    const tag = document.querySelector(`.interactive-map__tag[data-location="${id}"]`);
    
                    setActive(id);
    
                    if (tag) {
                        tag.scrollIntoView({ behavior: 'smooth', inline: 'center' });
                    }
    
                    preserveScroll();
                });
            });
        }





        // Desktop hover linking (for md and up)
        const handleHoverTag = () => {
            if (window.innerWidth < 768) return;

            const wrapper = document.querySelector('.interactive-map__image-wrapper');
            if (!wrapper) return;

            const wrapperRect = wrapper.getBoundingClientRect();
            const margin = 10; // px padding from edges

            locations.forEach(location => {
                const id = location.dataset.location;
                const tag = document.querySelector(`.interactive-map__tag[data-location="${id}"]`);
                if (!tag) return;

                const rect = location.getBoundingClientRect();

                // Get initial tag positions relative to wrapper
                let tagTop = rect.top - wrapperRect.top;
                let tagLeft = rect.left - wrapperRect.left;

                // Tag dimensions
                const tagWidth = tag.offsetWidth || 180;
                const tagHeight = tag.offsetHeight || 80;

                // Horizontal clamp with margin
                const minLeft = (tagWidth / 2) + margin;
                const maxLeft = wrapperRect.width - (tagWidth / 2) - margin;
                tagLeft = Math.min(Math.max(tagLeft, minLeft), maxLeft);

                // Vertical clamp to prevent tag from going above wrapper
                const desiredOffsetY = -200; // your chosen spacing (as a % of tag height)
                const offsetPx = (Math.abs(desiredOffsetY) / 100) * tagHeight;
                const topLimit = offsetPx + margin; // ensures tag stays visible
                if (tagTop < topLimit) tagTop = topLimit;

                // Apply initial style
                tag.style.position = 'absolute';
                tag.style.top = `${tagTop}px`;
                tag.style.left = `${tagLeft}px`;
                tag.style.transform = 'translate(-50%, -200%)';
                tag.style.opacity = '0';
                tag.style.pointerEvents = 'none';

                // Hover events
                location.addEventListener('mouseenter', () => {
                    tag.style.opacity = '1';
                    tag.classList.add('is-active');
                });

                location.addEventListener('mouseleave', () => {
                    tag.style.opacity = '0';
                    tag.classList.remove('is-active');
                });
            });
        };

        handleHoverTag();
        window.addEventListener('resize', handleHoverTag);




    });
};

export default InteractiveMap;
